const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgNXYySDV2MTJoMTJ2LTVoMnY1YTIgMiAwIDAgMS0yIDJINWEyIDIgMCAwIDEtMi0yVjdhMiAyIDAgMCAxIDItMmg1em0xMC45OTctMnY4aC0yVjYuNDE0bC03LjI5MyA3LjI5My0xLjQxNC0xLjQxNEwxNy41ODMgNWgtNC41ODZWM2g4eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";
export {
  M as default
};
//# sourceMappingURL=external_link-0cd968dd.mjs.map
